/* PackageEditorRenderer.js */

"use strict";

const GeneralTab = require("./tabs/packageeditorgeneraltab/PackageEditorGeneralTabComponent");
const InstallTab = require("./tabs/packageeditorinstalltab/PackageEditorInstallTabComponent");
const PreviewTab = require("./tabs/packageeditorpreviewtab/PackageEditorPreviewTabComponent");
const ExportTab = require("./tabs/packageeditorexporttab/PackageEditorExportTabComponent");

const _ = require("lodash");
_.mixin(require("underscore.string").exports());

class PackageEditorRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("package-editor-gl");
        this._rootElem.component = this._model;

        this._contentElem = undefined;
        this._contentTabsElem = undefined;

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve, reject) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            if (this._currentComponent) {
                this._currentComponent.shutdown().then(resolve, reject);
            } else {
                resolve();
            }
        });
        return prom;
    }
    _registerListeners() {
        this._model.on("Shutdown", (this._onShutdown = this._onShutdown.bind(this)));
        this._model.on("EditorModeChanged", (this._onEditorModeChanged = this._onEditorModeChanged.bind(this)));
        this._model.on("ResizeContainer", (this._onResizeEvent = this._onResizeEvent.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeListener("Shutdown", this._onShutdown);
        this._model.removeListener("EditorModeChanged", this._onEditorModeChanged);
        this._model.removeListener("ResizeContainer", this._onResizeEvent);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        //set the title

        let renderContentProm = this.renderContent();
        this.renderTabs();
        if (!this._rootElem.hasChildNodes()) {
            let header = document.createElement("div");
            header.classList.add("package-editor-header");
            this.rootElement.appendChild(header);
            this.rootElement.appendChild(this._contentElem);
            this.rootElement.appendChild(this._contentTabsElem);
        }
        return renderContentProm;
    }
    renderTabs() {
        if (!this._contentTabsElem) {
            this._contentTabsElem = document.createElement("package-editor-content-tabs");

            let tabNames = ["general", "preview", "install"];
            if (this._model.getRepoType() === "DB") {
                tabNames.push("export");
            }
            tabNames.forEach((tabName) => {
                let tabElem = document.createElement("package-editor-content-tab");
                tabElem.dataset.editorMode = _.underscored(tabName);
                tabElem.innerText = _.titleize(_.humanize(tabName));
                tabElem.addEventListener("click", (e) => {
                    let eMode = e.target.dataset.editorMode;
                    this._model.setEditorMode(eMode);
                });
                this._contentTabsElem.appendChild(tabElem);
            });
        }
        //change selected tab
        let currentSelectedTab = this._contentTabsElem.querySelector("package-editor-content-tab.selected");
        if (currentSelectedTab) {
            currentSelectedTab.classList.remove("selected");
        }
        let newSelectedTab = this._contentTabsElem.querySelector("package-editor-content-tab[data-editor-mode=" + this._model.editorMode + "]");
        newSelectedTab.classList.add("selected");
    }
    renderContent() {
        if (!this._contentElem) {
            this._contentElem = document.createElement("package-editor-content");
        }
        switch (this._model.editorMode) {
            case "preview":
                this._currentComponent = new PreviewTab(this._model);
                break;
            case "install":
                this._currentComponent = new InstallTab(this._model);
                break;
            case "export":
                this._currentComponent = new ExportTab(this._model);
                break;
            default:
                this._currentComponent = new GeneralTab(this._model);
                break;
        }
        this._contentElem.innerHTML = "";
        this._contentElem.appendChild(this._currentComponent.renderer.rootElement);
        return this._currentComponent.renderer.render();
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onShutdown() {
        this._shutdown();
    }
    _onEditorModeChanged() {
        this.render();
    }
    _onResizeEvent(/*width, height*/) {
        let crs = this._rootElem.getClientRects();
        if (crs && crs.length) {
            let clientRect = crs[0];
            let width = clientRect.width;
            let height = clientRect.height;
            if (_.isFunction(_.get(this._currentComponent, "resizeContainer"))) {
                this._currentComponent.resizeContainer(width, height);
            }
        }
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = PackageEditorRenderer;
